export const OperacionContraparteFields = {
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    CodEstado: 'codOperacionContraparteEstado',
    CodSectorComercial: 'codSectorComercial',
    NombreSectorComercial: 'nombreSectorComercial',
    FechaAprobacion: 'fechaAprobacion',
    FechaVencimiento: 'fechaVencimiento',
    FechaAlta: 'fechaAlta',
    IdUsuarioAlta: 'idUsuarioAlta',
    Cuentas: 'cuentas',
    BitEnvio: 'enviar',
    PermiteEditar: 'permiteEditarOperacion',
    PermiteEliminar: 'permiteEliminarOperacion',
    NombreUsuarioAlta: 'nombreUsuarioAlta',
    ApellidoUsuarioAlta: 'apellidoUsuarioAlta',
    MailUsuarioAlta: 'mailUsuarioAlta'
} as const

export const OperacionContraparteCuentaFields = {
    NroCuenta: 'nroCuenta',
    RazonSocial: 'razonSocial',
    CodMoneda: 'codMoneda',
    DescMoneda: 'descMoneda',
    SimboloMoneda: 'simboloMoneda',
    Sector: 'descOperacionContraparteCuentaDetalleSeccion',
    Detalles: 'detalles',
    Importe: 'importe',
    ImporteConcertacion: 'importe_Concertacion',
    ImporteDPV: 'importe_DPV',
    ImporteFOP: 'importe_FOP',
    PermiteModificar: 'permiteModificar',
    Estilo: 'estilo',
} as const



export const OperacionContraparteLimiteFields = {
    NroCuenta: 'nroCuenta',
    RazonSocial: 'razonSocial',
    CodMoneda: 'codMoneda',
    DescMoneda: 'descMoneda',
    SimboloMoneda: 'simboloMoneda',
    ImporteConcertacion: 'importe_Concertacion',
    ImporteDPV: 'importe_DPV',
    ImporteFOP: 'importe_FOP',
    Sector: 'descOperacionContraparteCuentaDetalleSeccion',
    Estilo: 'estilo',
    PermiteModificar: 'permiteModificar',
    IdUsuarioAlta: 'idUsuarioAlta',
    FechaVencimiento: 'fechaVencimiento',
    FechaUltMod: 'fechaUltMod',
    UsuarioUltMod: 'usuarioUltMod',
    MensajeId: 'idMensaje',

    FechaAprobacion: 'fechaAprobacion',
    CodSectorComercial: 'codSectorComercial',
    NombreSectorComercial: 'nombreSectorComercial'
} as const;

export const OperacionContraparteLimitesSectorComercialFields = {
    CodSectorComercial: 'codSectorComercial',
    NombreSectorComercial: 'nombreSectorComercial',
    ListaLimites: 'limites'
} as const;

export const OperacionContraparteLimitesAprobadosPaisFields = {
    MensajeId: 'idMensaje',
    FechaAlta: 'fechaUltMod',
    UsuarioAlta: 'usuarioUltMod',
    NombrePais: 'nombrePais',
    CodPais: 'codPais',
    FechaAprobacion: 'fechaAprobacion',
    FechaVencimiento: 'fechaVencimiento',
    ListaSectores: 'sectores'
} as const;